
import storeData from '@/plugin/localStorage'
import cookies from '@/plugin/cookie'
const state = {
  token: storeData.get('token') ? storeData.get('token') : '',
  nickname: storeData.get('nickname') ? storeData.get('nickname') : '',
  uid: storeData.get('uid') ? storeData.get('uid') : '', // 用户名昵称
  parSid: cookies.get('parSid') ? cookies.get('parSid') : '', // cookieId
  cateId: []
}
const mutations = {
  CLEAR_USERINFO (state, data) {
    storeData.set('token', '')
    state.token = ''
    state.nickname = ''
    state.uid = ''
    storeData.set('nickname', '')
    storeData.set('uid', '')
    cookies.set('uid', '')
    state.parSid = ''
    cookies.set('parSid', '')
  },
  SET_TOKEN (state, data) {
    state.token = data
    storeData.set('token', data)
  },
  SET_USERINFO (state, data) {
    state.nickname = data.custName
    state.uid = data.custNo
    storeData.set('nickname', data.custName)
    storeData.set('uid', data.custNo)
    cookies.set('uid', data.custNo)
  },
  SET_COOKIEID (state, data) {
    state.parSid = data
    cookies.set('parSid', data)
  },
  SET_CATEGORY (state, data) {
    state.cateId = data
    console.log(state)
  }

}
const actions = {

}
export default {
  state,
  mutations,
  actions
}
